import style from './announceNetwrk.module.scss';

import StatisticPanel from 'containers/statisticPanel/statisticPanel';
import * as CurrentSubscriptionCreators from 'creators/currentSubscription';
import * as StatsCreators from 'creators/stats';
import State from 'interfaces/state/State';
import { IStatTrack } from 'interfaces/state/StatsState';
// eslint-disable-next-line
import React, { memo, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as StatsSelectors from 'selectors/stats';
import { S3URL } from 'utils/s3Url';
import { isAuth$, userEmail$ } from 'selectors/auth';
import { fetchSubscribedPromotion, subscribeToPromotion } from 'creators/promotions';
import { catchedErrorNotification } from 'utils/error';
import { CustomSvgIcon } from 'utils/CustomSvgIcon';
import { svgPathAttr } from 'utils/SVGPath';
import { message } from 'utils/message';
import { NETWRK_GROUP_URL } from 'constants/index';
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
// Only used by the affiliate / Micro-Promoters notice below, which is commented
// out. `noUnusedLocals` is on, so this has to stay commented with it.
// import { Link } from 'react-router-dom';

interface IProps { }

interface IStateProps {
  activeJobsCount: number;
  active_jobs_all: number;
  tracks: IStatTrack[];
}

interface IDispatchProps {
  getStats: () => void;
  fetchCurrentSubscription: () => void;
}

const AnnounceNetwrkPage = ({
  activeJobsCount,
  active_jobs_all,
  tracks,
  getStats,
  fetchCurrentSubscription,
}: IProps & IStateProps & IDispatchProps) => {
  const [email, setEmail] = useState('');
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
  const [thumbnailLoading, setThumbnailLoading] = useState(true);


  const isAuth = useSelector(isAuth$);
  const userEmail = useSelector(userEmail$);
  const isSubscribed = useSelector((state: State) => state.microPromotion.isSubscribed);

  const dispatch = useDispatch();

  // The signed-in email rides along purely to prefill the Netwrk join form, so
  // people do not retype what SmashHaus already knows. Netwrk treats it as a
  // prefill and nothing more — they still confirm and consent there.
  const netwrkGroupUrl = userEmail ? `${NETWRK_GROUP_URL}&email=${encodeURIComponent(userEmail)}` : NETWRK_GROUP_URL;

  const toggleVideoPopup = () => {
    setIsVideoPopupOpen((prevState) => !prevState);
  };

  // eslint-disable-next-line
  useEffect(() => {
    if (isAuth) {
      getStats();
    }
    // eslint-disable-next-line
  }, [isAuth]);

  useEffect(() => {
    if (userEmail) setEmail(userEmail!);
  }, [userEmail]);

  useEffect(() => {
    if (userEmail) {
      dispatch(fetchSubscribedPromotion(userEmail, 'netwrk_promotion'));
    }
  }, [userEmail, dispatch]);

  // eslint-disable-next-line
  useEffect(() => {
    if (isAuth) fetchCurrentSubscription();
  }, [isAuth, fetchCurrentSubscription]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) {
      catchedErrorNotification(new Error(message.emptyEmail));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      catchedErrorNotification(new Error(message.invalidEmail));
      return;
    }

    dispatch(subscribeToPromotion(email, 'netwrk_promotion', message.subscribeToPromotion));
  };

  return (
    <section className='info-c'>
      <div className="musician-content d-flex flex-column align-center show-animation">
        <div className="info-container-mus">
          <StatisticPanel getStats={getStats} tracks={tracks} allJobsCount={active_jobs_all} activeCount={activeJobsCount} />
        </div>
      </div>
      {isSubscribed && (
        <div className={style.optedInMsg}>THANK YOU! You are on our Beta list and we will notify you soon as we go live!</div>
      )}
      <div className={`${style.root} ${isSubscribed ? style.rootAlert : ""}`}>
        <div className={style.container}>
          <div className={style.announceNetwrkLabelsAndFormWrapper}>
            <div className={style.announceNetwrkLabelsBox}>
              <p className={style.labelPara}>COMING SOON</p>
              <h1 className={style.labelHead}>Your Music Netwrk</h1>
              <p className={style.labelDesc}>The Best Way To Discover, Organize and Activate <br /> Your Music Industry Relationship Network</p>
              {/*
                OPT IN and JOIN THE MUSIC INDUSTRY NETWRK share one row and one
                class, so the two read as a matched pair. The join link stays
                outside the <form> because it must keep rendering after someone
                has opted in, which is when the form itself is gone.
              */}
              <div className={style.announceNetwrkFormBox}>
                <div className={style.announceNetwrkCtaRow}>
                  {!isSubscribed && (
                    <form className={style.announceNetwrkForm} onSubmit={handleSubmit}>
                      <button type="submit" className={style.submitAnnounceNetwrkMail}>
                        OPT IN <CustomSvgIcon width={svgPathAttr.arrowRight.width} height={svgPathAttr.arrowRight.height} viewBox={svgPathAttr.arrowRight.viewBox} svgFill={svgPathAttr.arrowRight.svgFill} pathFill={svgPathAttr.arrowRight.pathFill} path={svgPathAttr.arrowRight.d} />
                      </button>
                    </form>
                  )}
                  <a
                    href={netwrkGroupUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={style.submitAnnounceNetwrkMail}
                  >
                    JOIN THE MUSIC INDUSTRY NETWRK{' '}
                    <CustomSvgIcon
                      width={svgPathAttr.arrowRight.width}
                      height={svgPathAttr.arrowRight.height}
                      viewBox={svgPathAttr.arrowRight.viewBox}
                      svgFill={svgPathAttr.arrowRight.svgFill}
                      pathFill={svgPathAttr.arrowRight.pathFill}
                      path={svgPathAttr.arrowRight.d}
                    />
                  </a>
                </div>
              </div>
              {/*
                Affiliate / Micro-Promoters notice — hidden 2026-09-15 on request.
                Left in place rather than deleted so it can be switched back on once
                the Micro-Promoter tech ships. Restoring it also means uncommenting
                the `Link` import at the top of this file; its .infoBox / .infoPara /
                .infoLink styles are still in announceNetwrk.module.scss.

              <div className={style.infoBox}>
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#3182ce" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12" y2="8"></line>
                </svg>
                <p className={style.infoPara}>
                  While we boot up the new tech to support <br /><strong>Micro-Promoters</strong>, you can start earning today by inviting music makers to the SmashHaus team via our affiliate program
                  <Link to="/affiliate" className={style.infoLink}>HERE</Link>.
                </p>
              </div>
              */}
            </div>
          </div>
          <div className={style.videoThumbnailWrapper}>
            {thumbnailLoading && (
              <div className={style.skeletonLoader} />
            )}
            <img
              src={S3URL.netwrkThumbnail}
              onLoad={() => setThumbnailLoading(false)}
              className={`${style.thumbnail} ${thumbnailLoading ? style.hidden : style.visible}`}
              alt="NETWRK Video Thumbnail"
            />
            {!thumbnailLoading && (
              <div onClick={toggleVideoPopup} className={style.playBtnOverlay}>
                <PlayCircleOutlineIcon className={style.playIcon} />
              </div>
            )}
          </div>
        </div>
      </div>

      {isVideoPopupOpen && (
        <div className={style.videoPopupWrapper}>
          <div className={style.overlay} onClick={toggleVideoPopup}></div>
          <div className={style.playerWrapper}>
            <button
              className={style.closeButton}
              onClick={(e) => {
                e.stopPropagation();
                toggleVideoPopup();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <video
              className={style.videoPlayer}
              controls
              autoPlay
              src={S3URL.netwrk}
            />
          </div>
        </div>
      )}
    </section>
  );
};

const mapStateToProps = (state: State) => {
  return {
    active_jobs_all: StatsSelectors.active_jobs_all$(state),
    activeJobsCount: StatsSelectors.active_jobs$(state),
    tracks: StatsSelectors.statisticTracks$(state),
  };
};

const mergeProps = (stateProps: IStateProps, dispatchProps: IDispatchProps, props: IProps) => {
  return {
    ...stateProps,
    getStats: dispatchProps.getStats,
    fetchCurrentSubscription: dispatchProps.fetchCurrentSubscription,
    ...props,
  };
};

export default connect(
  mapStateToProps,
  {
    getStats: StatsCreators.getStats,
    fetchCurrentSubscription: CurrentSubscriptionCreators.fetchCurrentSubscription,
  },
  mergeProps
)(memo(AnnounceNetwrkPage));
